import React from "react";

import i18n from "../../../constants/i18n";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { PASSWORD_BODY_PADDING_CSS } from "./change-password-constants";
import PasswordForm from "./password-form";
import ET3PageDiv from "../../../core/et3-page-div";

const ChangePassword = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  React.useEffect(() => {
    getCoreHistoryStore().setPageName("CHANGE_PASSWORD", "CHANGE_PASSWORD");
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("CHANGE_PASSWORD")}
        subTitle={i18n.get("CHANGE_PASSWORD_SUBTITLE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="row"
        alignItems="flex-start"
        justifyContent="center"
        color={colors.all.transparent}
        style={{
          boxSizing: "border-box",
          width: "100%",
          minWidth: 0,
          flexGrow: 1,
          paddingLeft: PASSWORD_BODY_PADDING_CSS,
          paddingRight: PASSWORD_BODY_PADDING_CSS,
          paddingTop: PASSWORD_BODY_PADDING_CSS
        }}
        onClick={() => {}}
      >
        <PasswordForm />
      </ET3Div>
    </ET3PageDiv>
  );
});
export default ChangePassword;
